@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

body {
    font-family: 'Outfit', sans-serif;
}

body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
